// TODO enable eslint
/* eslint-disable import/no-named-as-default */
import { all } from "redux-saga/effects"
import create from "./create"
import read from "./read"
import update from "./update"
import remove from "./remove"
import release from "./release"

export default function* saga() {
  while (true) {
    yield all({
      create: create(),
      read: read(),
      update: update(),
      remove: remove(),
      release: release(),
    })
  }
}
